import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={9 * (props.wx ?? 1)}
    height={26 * (props.hx ?? 1)}
    viewBox="0 0 9 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M1.41583 7.53849C1.46099 7.83258 1.53655 8.44414 1.80501 9.00594C2.06714 9.55401 2.3204 10.1073 2.41158 10.6966C2.90544 13.8787 2.80246 17.355 3.8438 21.1636C4.53648 23.6975 4.5808 25.2314 5.06833 25.3202C5.60948 25.4186 6.34226 23.8754 6.39629 21.063C6.47142 17.127 7.27595 13.233 7.46632 10.792C7.55581 9.64164 7.89182 9.02339 7.98848 8.71928C8.07121 8.45862 8.12693 8.16008 8.16112 7.82032C8.27636 6.68186 8.2506 4.36781 8.15225 2.77634C8.09484 1.84471 7.95767 1.46337 7.20927 1.40247C5.59681 1.27139 3.28956 1.31075 1.84342 1.48305C1.32212 1.54506 1.27653 1.88147 1.26218 2.49674C1.22798 3.99575 1.19422 6.09815 1.41583 7.53849Z"
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgNormal;
